module.exports = __webpack_public_path__ + "img/999.76380183.png";